/* eslint-disable require-await */
/* eslint-disable arrow-body-style */

import { configCenterClient } from '../api/config_info/arch/oec_arch_config_center_gw';

type IPagePattern = {
  [key: string]: string;
};

interface urlRegexConfKey {
  urlRegex: string[];
  btmFullCode: string;
  pagePath: string[];
}

/**
 * 获取tcc页面规则信息
 * @param appName 应用名称，服务端写死
 * @returns
 */
export const fetchTccConfig = async (appName: string, config: string) => {
  let tccData: any = {};
  try {
    const res = await configCenterClient.GetConfig({
      domain_name: 'gec_universal_data_collection',
      app_name: appName || 'default_app_name',
      config_name: config
    });
    tccData = res;
  } catch {
    tccData = {};
  }
  return tccData;
};

function formatPagePath(pagePath: string) {
  return `${pagePath.replace(/:id/g, '([^/]+)')}(\\?.*)?$`;
}

export function sortObjectByKeyLength(obj: IPagePattern): IPagePattern {
  const sortedKeys = Object.keys(obj).sort((a, b) => b.length - a.length);

  const sortedObject: IPagePattern = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });

  return sortedObject;
}

export function getFormatPagePattern(obj: urlRegexConfKey[], btmAId: string): IPagePattern {
  const newPagePattern: Record<string, string> = {};
  obj.forEach(({ urlRegex, pagePath, btmFullCode }) => {
    if (btmFullCode.indexOf(btmAId) !== -1) {
      if (urlRegex.length !== 0) {
        for (const patteren of urlRegex) {
          newPagePattern[patteren] = btmFullCode;
        }
      } else {
        for (const patteren of pagePath) {
          newPagePattern[formatPagePath(patteren)] = btmFullCode;
        }
      }
    }
  });
  return sortObjectByKeyLength(newPagePattern);
}
